import ConnectedDashboardPage from "./Connected";

export default ConnectedDashboardPage;
